import { useEffect, useState } from 'react'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { getInnerWidth } from '../../../../helpers/device'
import { COMPANY_TYPES } from '../../../../utils/common'
import { responsive } from '../../../../utils/layout'
import { ChartComponent } from './ChartComponent'

export const BlockChart = ({ data }) => {
  const [isChangeLayout, setIsChangeLayout] = useState(false)

  const CHART_RIGHT_LABEL = [
    COMPANY_TYPES.CORPORATE,
    COMPANY_TYPES.FUNDS,
  ].includes(data?.companyType)
    ? 'domesticSearchPreview.DOMESTIC_SEARCH_TOTAL_REVENUE'
    : [COMPANY_TYPES.LIFE_INSURANCE, COMPANY_TYPES.NON_LIFE_INSURANCE].includes(
        data?.companyType,
      )
    ? 'domesticSearchPreview.DOMESTIC_SEARCH_INSURANCE_PREMIUM'
    : 'domesticSearchPreview.DOMESTIC_SEARCH_TOTAL_OPERATING_INCOME'

  const getChartData = (chartData) => {
    if (chartData && chartData.length > 0) {
      let isKeepItemFlag = false
      const newestItem = [...chartData].sort(
        (a, b) => b.realYear - a.realYear,
      )[0]
      return [...new Array(5)]
        .map((_, index) => {
          const currentYear = newestItem.realYear - 4 + index
          const item = chartData.find((each) => each.realYear === currentYear)
          if (item) {
            isKeepItemFlag = true
            return item
          } else if (isKeepItemFlag) {
            return Object.keys(newestItem).reduce(
              (obj, key) => ({
                ...obj,
                [key]: key === 'realYear' ? currentYear : null,
              }),
              {},
            )
          }
          return null
        })
        .filter((item) => !!item)
    }
  }

  useEffect(() => {
    const resize = () => {
      if (getInnerWidth() < responsive.PIVOT_WIDTH) {
        setIsChangeLayout(true)
      } else {
        setIsChangeLayout(false)
      }
    }

    resize()
    window.addEventListener('resize', resize)

    return () => window.removeEventListener('resize', resize)
  }, [])

  return (
    <div className={isChangeLayout ? 'flexColumn' : 'dFlex'}>
      <div className={['px2', isChangeLayout ? 'w100' : 'w50'].join(' ')}>
        <div className="mb2 textCenter fw600">
          <Translate value="domesticSearchPreview.DOMESTIC_SEARCH_TOTAL_ASSET" />
        </div>
        <div style={{ width: '100%', position: 'relative' }}>
          {getChartData(data?.totalAssets) ? (
            <ChartComponent
              data={getChartData(data?.totalAssets)}
              width={'100%'}
              height={300}
              xAxisKey="realYear"
              yAxisKey="value"
              labelTooltip={I18n.t(
                'domesticSearchPreview.DOMESTIC_SEARCH_TOTAL_ASSET',
              )}
            />
          ) : (
            <Element
              className="wh100 dFlex alignItemsCenter justifyContentCenter"
              style={{ color: '#9c9c9c' }}
            >
              <Translate value="common.NO_DATA" />
            </Element>
          )}
        </div>
      </div>
      <div className={['px2', isChangeLayout ? 'w100 mt3' : 'w50'].join(' ')}>
        <div className="mb2 textCenter fw600">
          <Translate value={CHART_RIGHT_LABEL} />
        </div>
        <div style={{ width: '100%', position: 'relative' }}>
          {getChartData(data?.revenues) ? (
            <ChartComponent
              data={getChartData(data?.revenues)}
              width={'100%'}
              height={300}
              xAxisKey="realYear"
              yAxisKey="value"
              labelTooltip={I18n.t(CHART_RIGHT_LABEL)}
            />
          ) : (
            <Element
              className="wh100 dFlex alignItemsCenter justifyContentCenter"
              style={{ color: '#9c9c9c' }}
            >
              <Translate value="common.NO_DATA" />
            </Element>
          )}
        </div>
      </div>
    </div>
  )
}
